export default __webpack_public_path__ + "static/media/Mark-5-HUD-Header.43683a02.jpg";